// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase, ref } from 'firebase/database';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDEqqPenrBzLDUTQDTojIpu7-TnTQhBJRw',
  authDomain: 'queue-app-421da.firebaseapp.com',
  databaseURL: 'https://queue-app-421da-default-rtdb.firebaseio.com',
  projectId: 'queue-app-421da',
  storageBucket: 'queue-app-421da.appspot.com',
  messagingSenderId: '447460227986',
  appId: '1:447460227986:web:e0ed235bc66d518a94df4b',
  measurementId: 'G-DQ985FKZBK',
};
export const APP_VAPID_KEY =
  'BIjB3mp5FGAHDXitKfZmbihn9B1p9YLCuw5ZRjfNhQvzrSNkElucSET_gUJ3zCxOEuPzfroFPtsXVt1sdcfDiFo';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const dbQueues = ref(db, 'queues');
export const auth = getAuth(app); // Messaging service
export const messaging = getMessaging(app);

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in
    localStorage.setItem(
      'user',
      JSON.stringify({ uid: user.uid, email: user.email })
    );
  } else {
    // No user is signed in
    localStorage.removeItem('user');
  }
});

export { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut };
